// third-party
import { combineReducers } from 'redux';

// project import
import clientDataSlice from './clientDataSlice';
import financialModalSlice from './financialModalSlice';
import ledgerReportSlice from './ledgerReportSlice';
import selectedClientSlice from './selectedClientSlice'
import postponedChecksSlice from './postponedChecksSlice'
import reportPeriodSlice     from './reportPeriodSlice';
import documentCountsSlice from './documentCountsSlice';
import mainPageDataSlice from './mainPageDataSlice';
import documentPageSlice from './documentPageSlice';
import documentEnumsSlice from './documentEnumsSlice';
import journalEntryPageSlice from './journalEntryPageSlice';
import paymentAcceptancePageSlice from './paymentAcceptancePageSlice';
import paymentAcceptanceEnumsSlice from './paymentAcceptanceEnumsSlice';
import transactionDocumentPageSlice from './transactionDocumentPageSlice';
import accountCardsTablePageSlice from './accountCardsTablePageSlice';
import receivablesPageSlice from './receivablesPageSlice';
// ==============================|| COMBINE REDUCERS ||============================== //

const appReducer = combineReducers({ 
  clientDataSlice, 
  financialModalSlice, 
  ledgerReportSlice, 
  selectedClientSlice,
  postponedChecksSlice, 
  reportPeriodSlice,
  documentCountsSlice,
  mainPageDataSlice,
  documentPageSlice,
  documentEnumsSlice,
  journalEntryPageSlice,
  paymentAcceptancePageSlice,
  paymentAcceptanceEnumsSlice,
  transactionDocumentPageSlice,
  accountCardsTablePageSlice,
  receivablesPageSlice
});

/** Full in-memory Redux wipe (logout / switch user). Persist storage is purged separately. */
export const RESET_APP_STATE = 'RESET_APP_STATE';

const reducers = (state, action) => {
  if (action.type === RESET_APP_STATE) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default reducers;